import axios from 'axios';

const getLanguage = () => localStorage.getItem("lang") || localStorage.getItem("i18nextLng") || "ar";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_PROVIDER2}`,
    headers: {
        platform: 'agent',
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const language = getLanguage();
    config.headers = config.headers || {};
    config.headers["Accept-Language"] = language;
    config.headers.language = language;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {

        if (parseInt(error.response?.status) === 401) {



            localStorage.removeItem("token")
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;